import { ChangeEvent, FocusEvent, KeyboardEvent, MutableRefObject, ReactNode } from "react";
import cx from "classnames";
import { uid } from "uid";

import styles from "../Input.scss";
import InputWrapper from "../InputWrapper";

import { InputType, MetaType } from ".";

interface TextInputProps {
  input: InputType;
  meta: MetaType;
  additionalClasses?: string;
  autoComplete?: string;
  label?: string;
  placeholder?: string;
  sideSymbol?: () => React.ReactNode | "";
  testId?: string;
  isDisabled?: boolean;
  isLocked?: boolean;
  innerRef?: MutableRefObject<HTMLInputElement>;
  type?: "email" | "text" | "password" | "month";
  tabIndex?: number;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: ReactNode;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  min?: string | number;
  max?: string | number;
  readOnly?: boolean;
}

const TextInput = ({
  additionalClasses = "",
  autoComplete = "off",
  isDisabled = false,
  isLocked = false,
  label = "",
  placeholder = "",
  sideSymbol,
  input,
  meta,
  type = "text",
  testId,
  innerRef,
  tabIndex,
  ...restProps
}: TextInputProps) => (
  <InputWrapper sideSymbol={sideSymbol} input={input} meta={meta} isDisabled={isDisabled}>
    <input
      {...input}
      value={input?.value || ""}
      className={cx(styles.input, {
        [styles.removeAdditionalPadding]: !sideSymbol,
        [styles.isLocked]: isLocked,
        additionalClasses
      })}
      type={type}
      placeholder={placeholder}
      // disable HTML autoComplete
      name={undefined}
      // uid prevents Chrome's autofill
      autoComplete={autoComplete === "off" ? uid(10) : autoComplete}
      aria-label={label}
      data-testid={testId || `textInput:${input?.name}`}
      data-name={input && input.name}
      disabled={isDisabled || isLocked}
      ref={innerRef}
      tabIndex={tabIndex}
      {...restProps}
    />
  </InputWrapper>
);

export default TextInput;
